import { Directive, OnInit, ElementRef, Output, EventEmitter, HostBinding, HostListener } from '@angular/core'
import { DomUtils } from '@mprep/shared/lib/helpers'

@Directive({
  selector: '[mpClickedOutside]'
})
export class ClickedOutsideDirective implements OnInit {

  private _argument: any
  private _domElement: HTMLElement
  private _mpClickedOutside: EventEmitter<CustomMouseEvent> = new EventEmitter<CustomMouseEvent>()

  @Output('mpClickedOutside')
  public get mpClickedOutside() {
    return this._mpClickedOutside
  }

  public constructor(private _element: ElementRef, private _domUtils: DomUtils) { }

  @HostListener('document:click', ['$event'])
  public onDocumentClick($event) {
    if (this.clickWasOutsideElement($event)) {
      this._mpClickedOutside.emit(this.wrapEvent($event))
    }
  }

  public ngOnInit(): void {
    this._domElement = this._element.nativeElement
  }

  private clickWasOutsideElement(clickEvent: MouseEvent) {
    const domElement = this._domElement
    return domElement.offsetWidth > 0 && domElement.offsetHeight > 0 &&
      !this._domUtils.hasParentNode(<Element> clickEvent.target || clickEvent.srcElement, domElement)
  }

  private wrapEvent($event): CustomMouseEvent {
    const element = $event.target
    const wrappedEvent = {
      originalEvent: $event,
      targetElement: element,
    }
    return wrappedEvent
  }

}

interface CustomMouseEvent {
  originalEvent: any,
  targetElement: any
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/clicked-outside.directive.ts